import React, { useEffect } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Box,
    CircularProgress,
} from "@mui/material";

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    content: string;
    onClose: () => void;
    onConfirm: () => void;
    showConfirm?: boolean;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmColor?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
    isProcessing?: boolean; // flag from outside,
    processingContent: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title,
    content,
    onClose,
    onConfirm,
    showConfirm = true,
    confirmLabel = "Delete",
    cancelLabel = "Cancel",
    confirmColor = "error",
    isProcessing = false,
    processingContent = "",
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {isProcessing ? processingContent : content}
                </DialogContentText>
                {isProcessing && (
                    <Box display="flex" justifyContent="center" mt={2}>
                        <CircularProgress size={24} />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isProcessing}>
                    {cancelLabel}
                </Button>
                {showConfirm && (
                    <Button
                        onClick={onConfirm}
                        color={confirmColor}
                        variant="contained"
                        disabled={isProcessing}
                    >
                        {confirmLabel}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
